import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectComponent } from '../../../shared/components/select/select.component';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TegelModule } from '@scania/tegel-angular-17';
import { DropDownOption } from '../../../shared/models/drop-down-option';

@Component({
  selector: 'app-dialog-totem',
  imports: [SelectComponent, ModalComponent, ReactiveFormsModule, TegelModule],
  templateUrl: './dialog-totem.component.html',
  styleUrl: './dialog-totem.component.scss',
})
export class DialogTotemComponent {
  @ViewChild(ModalComponent) modal!: ModalComponent;
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DialogTotemComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      localList: DropDownOption[];
    },
    private fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      local: [null, Validators.required],
    });
  }

  onSave(formData: any) {
    this.dialogRef.close(formData.local);

    if (this.modal) {
      this.modal.stopLoading();
    }
  }
}
